/**
 * The English or Bengali text, for places outside a component: toasts and alerts built in event
 * handlers, labels in lists and maps, error fallbacks in helpers. Components can use it too.
 *
 * Reads the language from the store each time it's called (not once at import), so text follows
 * the language the customer picked, including right after they change it. The store is required
 * lazily: this file is imported by modules the store itself depends on.
 */
export function trText(en: string, bn: string): string {
  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { store } = require('@/store') as typeof import('@/store');
    return store.getState().preferences.language === 'bn' ? bn : en;
  } catch {
    return en;
  }
}
